// extracted by mini-css-extract-plugin
export default {"tip":"tip_tip__WdmC7"};